/* Config */
export const SET_PROFILE_DATA = '__setProfileData'
export const OPEN_LOGIN_MODAL = '__openLoginModal'
export const CLOSE_LOGIN_MODAL = '__closeLoginModal'

export default {
  SET_PROFILE_DATA,
  OPEN_LOGIN_MODAL,
  CLOSE_LOGIN_MODAL,
}
